import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { FiBrowserEventsService } from '@fi-shared/fi-shared-services/fi-browser-events.service';
import { takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TooltipComponent, TooltipDirective } from 'ng2-tooltip-directive';

@Injectable()
export class FiTooltipService {
    private renderer: Renderer2;
    constructor(
        private fiBrowserEventsService: FiBrowserEventsService,
        private rendererFactory: RendererFactory2,
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    subscribeUpdatePositionOnMouseWheel(getTooltipRefFn: () => TooltipDirective, ngOnDestroy$: Observable<void>) {
        this.fiBrowserEventsService
            .getDocumentEventSubject$('wheel')
            .pipe(takeUntil(ngOnDestroy$))
            .subscribe(() => this.updateTooltipPositionOnScroll(getTooltipRefFn));
    }

    updateTooltipPositionOnScroll(getTooltipRefFn: () => TooltipDirective) {
        // HostListener runs change detection cycle => bad for performance
        const tooltipRef = getTooltipRefFn();
        if (tooltipRef.componentRef) {
            // for smooth updating tooltipPosition
            let idx = 0;
            const interval = setInterval(() => {
                if (idx < 20) {
                    this.updateTooltipPosition(tooltipRef);
                    idx++;
                } else {
                    clearInterval(interval);
                }
            }, 10);
        }
    }

    updateTooltipPosition(tooltipRef: TooltipDirective) {
        if (tooltipRef.componentRef) {
            tooltipRef.getElementPosition();
            const tooltipComponentRef: TooltipComponent = tooltipRef.componentRef.instance;
            tooltipComponentRef.data.elementPosition = tooltipRef.elementPosition;

            // fix wrong position of tooltip arrow after scroll
            const placements = ['top', 'right', 'bottom', 'left'];
            const tooltipElement: HTMLElement = tooltipComponentRef['elementRef'].nativeElement;
            placements.forEach((placement) => {
                this.renderer.removeClass(tooltipElement, 'tooltip-' + placement);
            });
            tooltipComponentRef.setPosition();
        }
    }
}
